import { useEffect } from 'react'

type TimeoutCallback = () => void

const RESET_EVENTS: Array<keyof WindowEventMap> = [
  'click',
  'mousemove',
  'keydown',
  'scroll',
  'touchstart'
]

export const useSessionTimeout = (
  timeoutMs: number,
  onTimeout: TimeoutCallback
) => {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return () => undefined
    }

    let timer: ReturnType<typeof setTimeout> | undefined

    const resetTimer = () => {
      if (timer) {
        window.clearTimeout(timer)
      }
      timer = window.setTimeout(() => {
        onTimeout()
      }, timeoutMs)
    }

    resetTimer()
    RESET_EVENTS.forEach((event) => window.addEventListener(event, resetTimer))

    return () => {
      if (timer) {
        window.clearTimeout(timer)
      }
      RESET_EVENTS.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      )
    }
  }, [timeoutMs, onTimeout])
}

export default useSessionTimeout
